import styled from 'styled-components';
var InputStyles = styled.input.withConfig({
  displayName: "Inputstyles__InputStyles",
  componentId: "pantheon__sc-1261mil-0"
})(["font-size:14px;width:380px;height:42px;padding:0 1rem;border-radius:3px;background-color:#f7f7f7;border:1px solid #d8d8d8;@media (max-width:576px){width:260px;height:42px;}"]);
export { InputStyles };